import 'date-fns'
import React, { useState } from 'react'
import { DatePicker } from '@mui/x-date-pickers'
import { useIntl } from 'react-intl'
import { withStyles } from '@mui/styles'
import { FormHelperText, Box, Typography, TextField } from '@mui/material'

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

import { textInputStyles } from './text-input.styles'
import { ThemeButton } from '../theme-button'

export const CustomTextInputDatepickerButton = withStyles(textInputStyles)(({
  classes,
  readOnly,
  buttonMessage,
  hiddenInput,
  ...props
}) => {
  const [open, setOpen] = useState(false)
  const objectDate = props.value
  const { formatMessage } = useIntl()
  const typographyVariant = props.fontSize === 'small' ? '2' : '1'

  const input = (
    <TextField
      variant="outlined"
      value={objectDate || ''}
      disabled={true}
      InputProps={{ className: classes.smallInput }}
    />
  )
  return (
    <div className={classes.root}>
      {props.title ? (
        <Typography variant={`subtitle${typographyVariant}`}>{props.title}</Typography>
      ) : null}
      {readOnly ? (
        <Typography
          variant={`body${typographyVariant}`}
          color="textSecondary"
          style={{ whiteSpace: 'pre-line' }}
        >
          {props.value ? props.value : '--'}
        </Typography>
      ) : (
        <>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Box display="flex" alignItems="center">
              <DatePicker
                {...props}
                open={open}
                disableToolbar
                inputVariant="outlined"
                format="dd/MM/yyyy"
                name={props.name}
                value={objectDate}
                onChange={(date) => {
                  props.onChange({ target: { name: props.name, value: date } })
                }}
                // InputProps={{ className: classes.smallInput }}
                okLabel={formatMessage({ id: 'picker.ok' })}
                cancelLabel={formatMessage({ id: 'picker.cancel' })}
                onAccept={() => setOpen(false)}
                onClose={() => setOpen(false)}
                TextFieldComponent={() => (hiddenInput ? null : input)}
              />
              <ThemeButton
                color="primary"
                size="small"
                className={classes.button}
                onClick={() => setOpen((isOpen) => !isOpen)}
              >
                {buttonMessage}
              </ThemeButton>
            </Box>
          </LocalizationProvider>
          <FormHelperText id="my-helper-text" error={props.error}>
            {props.error ? props.errorMessage : props.helpMessage}
          </FormHelperText>
        </>
      )}
    </div>
  )
})
